import React, { FC } from 'react'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { FlexRow } from '@/atoms/FlexContainers'
import { CartIcon } from '@/atoms/Icons/CartIcon'
import { InternalLink } from '@/atoms/InternalLink'
import { AngelLogo } from '@/atoms/Logos/AngelLogo'
import { EyebrowSM, TitleLG } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { useCollectiblesPurchaseContext } from '@/contexts/CollectiblesPurchaseContext/CollectiblesPurchaseContextProvider'
import { useThemeContext } from '@/contexts/ThemeContext'
import { UserMenu } from '@/organisms/SiteNav/UserMenu'
import { CollectiblesSideCart } from '@/views/CollectiblesCheckoutView/CollectiblesSideCart'

export type TicketNavVariantTypes = 'BACK' | 'CLOSE' | 'NONE'

export interface CollectiblesNavProps {
  title: string
  shouldHideOnMobile?: boolean
}

const CollectiblesNav: FC<CollectiblesNavProps> = ({ title, shouldHideOnMobile = false }) => {
  const { isDarkMode } = useThemeContext()
  const { setShowSideCart, momentsInCart, packsInCart } = useCollectiblesPurchaseContext()
  const { query } = useRouter()
  const projectId = query.projectId as string

  const cartItemsCount = momentsInCart.length + packsInCart.length

  const handleSideCartOpen = () => {
    setShowSideCart(true)
  }

  return (
    <>
      <header className={classNames(shouldHideOnMobile && 'hidden md:block')}>
        <nav
          className={classNames(
            'sticky top-0 z-50 flex h-16 items-center justify-between px-4',
            isDarkMode ? 'bg-core-gray-900' : 'bg-white',
          )}
        >
          <FlexRow className="gap-2 sm:gap-3">
            <InternalLink aria-label="Angel Studios" href={paths.home}>
              <AngelLogo color={isDarkMode ? 'white' : 'black'} />
            </InternalLink>
            <TitleLG
              className="relative text-base sm:absolute sm:left-1/2 sm:top-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 sm:text-lg md:text-2xl"
              color={isDarkMode ? 'white' : 'core-gray-950'}
              weight="bold"
            >
              {title}
            </TitleLG>
          </FlexRow>
          <FlexRow className="gap-3 sm:gap-6">
            <div className="relative cursor-pointer" onClick={handleSideCartOpen}>
              {cartItemsCount > 0 && (
                <div className="absolute -bottom-1 -right-2 flex min-h-4 min-w-4 items-center justify-center rounded-full bg-oxide-primary px-1 py-0.5">
                  <EyebrowSM color="white">{cartItemsCount}</EyebrowSM>
                </div>
              )}
              <CartIcon size={24} color="gray-950" />
            </div>

            <UserMenu loginButtonVariant={isDarkMode ? 'white' : 'black'} />
          </FlexRow>
        </nav>
      </header>
      <CollectiblesSideCart
        className="-top-5"
        checkoutLink={paths.collectibles.checkout(projectId)}
        projectId={projectId}
      />
    </>
  )
}

export default CollectiblesNav
